import { memo } from 'react';

import { GalleryNestedItemsChip } from '~/components/v2/components/shared/gallery/GalleryNestedItemsChip';

export const GalleryNestedEmptyStateHeader = memo(() => (
  // h-8 matches the gallery section header height so the chip doesn't shift between the empty and populated views.
  <div className="mt-6 flex h-8 items-center px-4">
    <GalleryNestedItemsChip />
  </div>
));

GalleryNestedEmptyStateHeader.displayName = 'GalleryNestedEmptyStateHeader';
